var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerTwoFrame2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.496 159.613H336.494C371.119 159.613 399.188 187.682 399.188 222.307C399.188 256.931 371.119 285 336.494 285H204.45C170.234 285 142.496 257.263 142.496 223.047V159.613Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M273.802 79.7186L336.495 79.7186L399.188 79.7186C399.188 114.343 371.12 142.412 336.495 142.412C301.87 142.412 273.802 114.343 273.802 79.7186Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.802 62.6935L336.495 62.6935L399.188 62.6935C399.188 28.0688 371.12 2.45385e-06 336.495 5.48084e-06C301.87 8.50782e-06 273.802 28.0688 273.802 62.6935Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0.0945032 222.123L62.788 222.123L125.481 222.123C125.481 256.748 97.4126 284.816 62.788 284.816C28.1633 284.816 0.0945001 256.748 0.0945032 222.123Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.883 136.496L205.19 136.496L142.496 136.496C142.496 101.872 170.565 73.8027 205.19 73.8027C239.814 73.8027 267.883 101.872 267.883 136.496Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerTwoFrame2);
export default __webpack_public_path__ + "static/media/CornerTwoFrame2.a66ee5e09923e73cc5e19b995bdaa7c1.svg";
export { ForwardRef as ReactComponent };